import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        mainId: this.paramsProps.mainId,
      },
    };
  },
  methods: {
    setColumn(col) {
      const item = col;
      if (item.field === 'checkTypeseq') {
        item.title = '序号';
        item.width = '50';
      }
      return item;
    },
  },
  created() {
    this.getConfigList('detail-list');
  },
};
